import {
  GET_APP_SWITCHER_URL,
  GET_APP_SWITCHER_URL_SUCCESS,
  GET_APP_SWITCHER_URL_ERROR,
  GET_APP_SWITCHER_URL_ERROR_MSG,
  RESET_APP_SWITCHER_DATA
} from "../constants";

export const appSwitcherInitialState = {
  isFetching: false,
  hasError: false,
  errorMsg: GET_APP_SWITCHER_URL_ERROR_MSG
};

export function reducer(state, { type, payload }) {
  switch (type) {
    case GET_APP_SWITCHER_URL:
      return { ...state, isFetching: true, dataId: payload, hasError: false };
    case GET_APP_SWITCHER_URL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        appSwitcherUrl: {
          ...payload
        }
      };
    case GET_APP_SWITCHER_URL_ERROR:
      return {
        ...state,
        isFetching: false,
        hasError: true
      };
    case RESET_APP_SWITCHER_DATA:
      return appSwitcherInitialState;
    default:
      return state;
  }
}
